module.exports = __webpack_public_path__ + "static/img/ic-quiz-bookmark-save.fdb59ccc.svg";